import React from "react";
import { Markdown } from 'react-showdown';
import DocumentationType from '../components/Type';
import { root } from '../utils/Manager';

export default function Constant({ docs }) {
    const pathSuffix = `${docs.sources.fileName}#L${docs.sources.line}`;

    return <>
        <h1>
            {docs.name} {docs.sources ? <a href={root + pathSuffix} style={{ fontSize: '20px' }}>{pathSuffix}</a> : null}
        </h1>

        <Markdown markdown={docs.comment.shortText || 'No documentation found.'}/>
        <hr style={{ marginTop: '15px'}}/>
        <h2 style={{ marginBottom: '10px' }}>Type: </h2>
        <DocumentationType type={docs.type}/>
    </>
}